export const getEndDate = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() + 120);
  return now;
};
